<template>
    <section class="home-page__custom-html-block">
        <BlockHtml :plain-text="content" />
    </section>
</template>

<script>
import BlockHtml from '~/src/components/BlockHtml';

export default {
    name: 'CustomHtmlBlock',
    components: {
        BlockHtml,
    },
    props: {
        content: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    .home-page__custom-html-block {
        width: 100%;
        margin: 0;
    }
</style>
